module.exports = "/_next/static/images/6cb36171bb2707b866fbdaaf244bd249-clips@tablet768.jpg.webp";